/* eslint-disable @typescript-eslint/no-magic-numbers */

export const stringToColor = (string: string): string => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

interface IStringAvatar {
  sx: { bgcolor: string };
  children: string;
}

export const stringAvatar = (
  name: string,
  size = 32,
  fontSize = "1rem",
): IStringAvatar => {
  const bgcolor = stringToColor(name);

  const sx = { bgcolor, width: size, height: size, fontSize };

  if (!name) {
    return {
      sx,
      children: `??`,
    };
  }

  const nameComputed = name.trim();

  if (!nameComputed.trim().includes(" ")) {
    return {
      sx,
      children: `${nameComputed[0]}`,
    };
  }

  return {
    sx,
    children: `${nameComputed.split(" ")[0][0]}${
      nameComputed.split(" ")[1][0]
    }`,
  };
};
